module.exports = "https://static.wmbcdn.com/uniweb/images/4eb93610bba7bb7238d8fd40ce53fd9b.svg";